class NotificationPopup extends HTMLElement {
  connectedCallback() {
    // Prevent multiple initializations when element is re-attached to DOM
    if (this._initialized) return;
    this._initialized = true;

    this.popup = document.querySelector(".not-pu-section");
    if (!this.popup) return;

    this.hasSubscription = this.dataset.hasSubscription === "true";
    this.delay = Number(this.dataset.delay) || 0;
    this.cookie = document.cookie.includes("hideNotificationPopup=true");

    // Create overlay and append to body
    this.overlay = document.createElement("div");
    this.overlay.className = "newsletter-popup-overlay";
    document.body.appendChild(this.overlay);

    if (this.hasSubscription || this.cookie) return;

    this._delayTimer = setTimeout(() => {
      this.popup.classList.remove("hidden");
      this.popup.classList.add("wt-popup-fade-in");
      this.overlay.classList.add("active");
    }, this.delay * 60000);

    this._closeHandler = (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.popup.classList.add("hidden");
      this.popup.classList.remove("wt-popup-fade-in");
      this.overlay.classList.remove("active");
      this.setCookie("hideNotificationPopup", "true", 7);
    };

    // Bind close buttons after a microtask to ensure DOM is ready
    requestAnimationFrame(() => {
      this.closeBtns = this.popup.querySelectorAll(".newsletter__close-btn");
      this.closeBtns.forEach((btn) => btn.addEventListener("click", this._closeHandler));
    });
  }

  disconnectedCallback() {
    // Clean up timer and event listeners when element is removed
    if (this._delayTimer) {
      clearTimeout(this._delayTimer);
    }
    if (this.closeBtns && this._closeHandler) {
      this.closeBtns.forEach((btn) => btn.removeEventListener("click", this._closeHandler));
    }
    if (this.overlay && this.overlay.parentNode) {
      this.overlay.parentNode.removeChild(this.overlay);
    }
    this._initialized = false;
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }
}

customElements.define("notification-popup", NotificationPopup);
